import { render, staticRenderFns } from "./Goodsaddprice.vue?vue&type=template&id=614ecaa0&"
import script from "./Goodsaddprice.vue?vue&type=script&lang=js&"
export * from "./Goodsaddprice.vue?vue&type=script&lang=js&"
import style0 from "./Goodsaddprice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports